import { render, staticRenderFns } from "./InvoiceRecovering.vue?vue&type=template&id=18d6dbfc&scoped=true"
import script from "./InvoiceRecovering.vue?vue&type=script&lang=js"
export * from "./InvoiceRecovering.vue?vue&type=script&lang=js"
import style0 from "./InvoiceRecovering.vue?vue&type=style&index=0&id=18d6dbfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d6dbfc",
  null
  
)

export default component.exports